import PropTypes from 'prop-types';
import wasPriceType from '../../_utils/types/was-price-type';

const modalContentType = PropTypes.shape({
  themeTitle: PropTypes.string,
  url: PropTypes.string,
  deliveryOptionKeys: PropTypes.arrayOf(PropTypes.number),
  previewImages: PropTypes.arrayOf(PropTypes.string),
  priceInfo: PropTypes.shape({
    price: PropTypes.number,
    price_range: PropTypes.arrayOf(PropTypes.number),
    set_size: PropTypes.number,
    was_price: wasPriceType,
  }),
});

export default modalContentType;
